
  import { Component, Vue, Watch } from 'vue-property-decorator'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import ActiveUser from '@/components/ActiveUser.vue'
  import List from '@/layouts/List.vue'
  import { Link, LinkGroup } from '@/store/app/state'
  import ScheduleBtn from '@/components/app/ScheduleBtn.vue'
  import GroupScheduleBtn from '@/components/app/GroupScheduleBtn.vue'
  import { ROLES_DASHBOARD_GROUP_ALLOWED, RoleSysop } from '@/store/user/state'
  import ListGroup from '@/layouts/ListGroup.vue'
  import { Role } from '@/store/user/models'
  import NotificationSystem from '@/components/global/NotificationSystem.vue'

  const { VUE_APP_WHATSAPP_LINK } = process.env

@Component({
  components: {
    NotificationSystem,
    ListGroup,
    ActiveUser,
    ScheduleBtn,
    GroupScheduleBtn,
    DrawerHeader: () =>
      import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader.vue'
        ),
    List,
  },
  methods: {
    ...mapActions('app', ['setMini', 'toggleDrawer']),
    ...mapMutations('app', ['setMenu']),
  },
  computed: {
    ...mapGetters('app', ['isMini', 'getStaticMenu', 'drawerOpened', 'isMobile']),
    ...mapGetters('resources', ['links', 'groupedLinks']),
    ...mapGetters('user', ['roles']),
    ...mapGetters('resources/datatables', ['datatableLoading']),
  },
})
  export default class Drawer extends Vue {
  isMobile!: boolean;
  groupedLinks!: Array<LinkGroup>;
  links!: Array<Link>;
  roles!: Array<Role>
  datatableLoading!: boolean;
  drawerOpened!: boolean;
  toggleDrawer!: (payload?: boolean) => void
  permanentDrawer = false

  isMini!: boolean;
  setMini!: (payload: boolean) => void;

  setMenu!: (payload: Link) => void;

  getStaticMenu!: Array<Link>;
  search = '';

  // Referencia al listener para poder removerlo correctamente
  private miniDrawerListener = (event: Event) => {
    this.handleMiniDrawer(event)
  }

  mounted () {
    document.addEventListener('is-mini-drawer', this.miniDrawerListener)
    document.addEventListener('open-drawer', this.handleOpenDrawer)
  }

  beforeDestroy () {
    document.removeEventListener('is-mini-drawer', this.miniDrawerListener)
    document.removeEventListener('open-drawer', this.handleOpenDrawer)
  }

  handleMiniDrawer (event: Event) {
    const customEvent = event as CustomEvent
    if (this.isMobile) {
      this.permanentDrawer = customEvent.detail.permanent
    }
  }

  handleOpenDrawer () {
    this.setMini(false)
  }

  get isDark (): boolean {
    return this.$vuetify.theme.dark
  }

  goWhatsapp () {
    window.open(VUE_APP_WHATSAPP_LINK, '_blank')
  }

  @Watch('roles', { immediate: true, deep: true })
  allowSchedule (val) {
    if (!val?.length) {
      return
    }
    if (val.some(role => ROLES_DASHBOARD_GROUP_ALLOWED[role.slug]) && !this.getStaticMenu.map(item => item.id).includes(3)) {
      this.setMenu(
        {
          id: 3,
          name: 'Agenda',
          icon: 'mdi-calendar-month',
          route: { name: 'schedule' },
          className: 'schedule-tutorial',
        },
      )
    }
    if (val.some(role => RoleSysop[role.slug]) && !this.getStaticMenu.map(item => item.id).includes(4)) {
      this.setMenu(
        {
          id: 4,
          name: 'Estatus usuario',
          icon: 'mdi-account-clock',
          route: { name: 'sysop-user' },
        },
      )
    }
  }

  async goHelp () {
    this.$router.push({ name: 'help' }).catch(() => {
    })
  }
  }

